module.exports = __webpack_public_path__ + "static/media/7.2751a53f.png";


//////////////////
// WEBPACK FOOTER
// ./src/display/modules/Home/Guide/image/7.png
// module id = 6915
// module chunks = 0